<script lang="ts">
  import Logo from '$mds/Logo';
</script>

<main class="flex min-h-screen flex-col py-4 md:py-6">
  <div class="auth-nav mb-2 flex items-center justify-between px-6 xl:px-10">
    <a href="/" class="-ml-3 p-3">
      <Logo variant="horizontal" theme="gradient" height="h-10" />
    </a>
  </div>
  <slot />
</main>
